import React from "react";
import Sidebar from "./Sidebar";

export default function Shell({ children }) {
  return (
    <div className="flex min-h-screen bg-white">
      <Sidebar />
      <main className="flex-1 min-w-0" data-testid="main-content">
        <div className="p-8 lg:p-12 max-w-[1400px]">{children}</div>
      </main>
    </div>
  );
}
